import { z } from "zod";

const INVISIBLE = /[\s­᠎​-‏⁠-⁤﻿]/gu;

const DIRECTION_CONTROL = /[‪-‮⁦-⁩]/u;

const HIDDEN_CHARACTER = /[\u00AD\u061C\u180E\u200B\u200E\u200F\u2060-\u2064\uFEFF]/u;

export const showsText = (value: string): boolean => value.replace(INVISIBLE, "").length > 0;

export const carriesDirectionControl = (value: string): boolean => DIRECTION_CONTROL.test(value);

const carriesHiddenCharacter = (value: string): boolean => HIDDEN_CHARACTER.test(value);

export const NAME_SHOWS_NOTHING = "must show at least one visible character";

export const NAME_REORDERS_TEXT =
  "must not carry text-direction controls, which make a name read as another";

const NAME_HIDES_CHARACTERS =
  "must not carry characters that draw nothing, which make a name look like another";

export const TEXT_REORDERS =
  "must not carry text-direction controls, which show the text in another order than it was written";

export const nameProblem = (value: string): string | null =>
  !showsText(value)
    ? NAME_SHOWS_NOTHING
    : carriesDirectionControl(value)
      ? NAME_REORDERS_TEXT
      : carriesHiddenCharacter(value)
        ? NAME_HIDES_CHARACTERS
        : null;

export const readsAsItself = (schema: z.ZodString): z.ZodString =>
  schema
    .refine(showsText, NAME_SHOWS_NOTHING)
    .refine((value) => !carriesDirectionControl(value), NAME_REORDERS_TEXT)
    .refine((value) => !carriesHiddenCharacter(value), NAME_HIDES_CHARACTERS);

export const userNameSchema = (max: number): z.ZodString =>
  readsAsItself(z.string().trim().min(1).max(max));
